module.exports = __webpack_public_path__ + "img/tarjeta-credito_2.f7e363c1.png";